<template>
    <div class="form-group" @keydown.enter.prevent.self>
        <label v-if="label" :for="name">{{ label }}</label>
        <span class="text-danger" v-if="required"> *</span>

        <multiselect :id="name" :name="name" v-model="vModel" :options="options || []" :multiple="multiple"
            :track-by="valueField" :label="labelField" :disabled="disabled" :placeholder="placeholder"
            @input="onChange" />

        <small class="form-text text-danger" v-if="errors && errors[error_name || name]"
            v-text="errors[error_name || name][0]" />
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    props: {
        label: String,
        name: {
            type: String,
            required: true,
        },
        model: {
            type: Object,
            required: true,
        },
        errors: Object,
        options: {
            type: Array,
            required: true,
        },
        labelField: {
            type: String,
            default: "label",
        },
        valueField: {
            type: String,
            default: "id",
        },
        value: null,
        multiple: Boolean,
        disabled: Boolean,
        error_name: String,
        required: Boolean,
    },
    computed: {
        placeholder() {
            return `${this.Lang.get("messages.select")} ${this.label || this.Lang.get("messages.option")}`;
        },
        vModel: {
            get() {
                if (!this.model || typeof this.model !== "object") return null;
                return _.get(this.model, this.name);
            },
            set(newValue) {
                if (this.model && typeof this.model === "object") {
                    _.set(this.model, this.name, newValue);
                }
            },
             set(val) {
      this.$emit("input", val); // 👈 هذا يرسل التحديث إلى v-model
    }
        },
    },
    watch: {
        options(newVal) {
            const newIDs = newVal.map((item) => item.id);
            const currentModel = _.get(this.model, this.name);
            if (Array.isArray(currentModel)) {
                const newModel = currentModel.filter((el) => newIDs.includes(el.id));
                _.set(this.model, this.name, newModel);
            }
        },
    },
    methods: {
        onChange(value) {
            this.$emit("change", value);
            this.$emit("keyup");
        },
    },
};
</script>
